// extracted by mini-css-extract-plugin
export var mergingIntoPill = "_gz-1";
export var rowFirst = "_gz-3";
export var rowLast = "_gz-5";
export var rowMiddle = "_gz-4";
export var ticketListScroll = "_gz-2";
export var ticketStack = "_gz-0";